import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { CreateLoadSchemaType, CreateLoadSchema } from 'apps/fleet-planner/schema'
import { ICreateLoadSchemaContext } from '../types/CreateLoadSchema'
import { CreateLoadDefaultValues, getDefaultLoadState } from '../utils/getDefaultLoadState'

interface IUseCreateLoadFormProps {
  defaultValues?: CreateLoadDefaultValues
  /**
   * Pass in contextual data that can be used
   * when validating the form data
   */
  context?: ICreateLoadSchemaContext
}

/**
 * RHF Hook for creating a new load
 */
export const useCreateLoadForm = ({ context, defaultValues }: IUseCreateLoadFormProps) => {
  return useForm<CreateLoadSchemaType, ICreateLoadSchemaContext>({
    mode: 'all',
    resolver: yupResolver(CreateLoadSchema),
    context,
    defaultValues: {
      ...CreateLoadSchema.cast(
        getDefaultLoadState({
          defaultValues,
        })
      ),
    },
  })
}
